import { compose } from 'recompose'
import { connect } from 'react-redux'
import {
  selectClientHasHomes,
  selectClientFetchId,
  selectClientId,
} from '../../../../store/selectors/client'

const NewHomeContainer = compose(
  connect(state => ({
    hasHomes: selectClientHasHomes(state),
    notFound: !selectClientId(state) && !selectClientFetchId(state),
  }))
)

export default NewHomeContainer
